const k = 1024;

export function formatBytes(bytes, decimals) {
  if (bytes == 0) return "0 Bytes";
  var dm = decimals <= 0 ? 0 : decimals || 2,
    sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
    i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
}

export const fileSizes = {
  KB: k,
  MB: Math.pow(k, 2),
  GB: Math.pow(k, 3),
  TB: Math.pow(k, 4),
  PB: Math.pow(k, 5)
};
